<app-identification-error-summary></app-identification-error-summary>
@if (vm.content && tenants.length > 0) {
   <div class="row">
      <div class="col-xs-12">
         <div class="accordion application-form">
            <div class="opener">
               <span class="num last"
                  >2
                  <i class="fa fa-check" aria-hidden="true"></i>
               </span>
               <h1>{{ vm.content.title }} - {{ vm.content.step2Title }}</h1>
               <p [innerHtml]="vm.content.step2Body"></p>
            </div>
            <div class="slide">
               <form action="#">
                  <fieldset>
                     <legend class="sr-only">{{ vm.content.step2SubTitle }}</legend>
                     <div class="section">
                        <div class="row section__heading">
                           <div class="col-sm-6">
                              <h2>{{ vm.content.step2SubTitle }}</h2>
                           </div>
                        </div>
                        <div class="form-group">
                           <label for="employment_status">{{ vm.content.step2Question }}</label>
                           <div class="step-two-tenants">
                              @for (tenant of tenants; track tenant.contactId) {
                                 <div class="row">
                                    <div class="col-xs-12 col-sm-4">
                                       <input
                                          type="radio"
                                          id="selection-{{ tenant.contactId }}"
                                          name="selection"
                                          [value]="tenant.contactId"
										  (change)="selectTenant(tenant)"
                                          [disabled]="tenant.registered || tenant.blocked"
                                          [checked]="vm.selectedContactId === tenant.contactId"
                                       />
                                       <label
                                          data-hj-suppress
                                          for="selection-{{ tenant.contactId }}"
                                          class="btn btn-secondary"
                                          [class.active]="vm.selectedContactId === tenant.contactId"
                                          [class.disabled]="tenant.registered || tenant.blocked"
                                       >
                                          {{ tenant.firstName }} {{ tenant.lastName }}
                                       </label>
                                    </div>
                                    @if (tenant.registered || tenant.blocked) {
                                       <div class="col-xs-12 col-sm-8">
                                          @if (tenant.registered) {
                                             <div data-hj-suppress [innerHTML]="processRegisteredMessage(tenant)"></div>
                                          }
                                          @if (tenant.blocked) {
                                             <div data-hj-suppress [innerHTML]="vm.content?.step2TenantBlocked || ''"></div>
                                          }
                                       </div>
                                    }
                                 </div>
                              }
                           </div>
                        </div>
                     </div>
                     <div class="section">
                        <div class="btn-set clearfix">
                           <button
                              type="button"
                              (click)="goNext()"
                              [disabled]="!vm.selectedContactId"
                              id="idvStep2ContinueButton"
                              class="btn btn-primary btn-send"
                           >
                              Continue
                           </button>
                           <button type="button" (click)="goBack()" id="idvStep2BackButton" class="btn btn-default">Back</button>
                        </div>
                     </div>
                  </fieldset>
               </form>
            </div>
         </div>
      </div>
   </div>
}
